import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Top100 from './containers/Top100Container';


const Top100App = ({ slug, listMusics }) => {
    const history = useHistory();

    return (<Top100 slug={slug} history={history} listMusics={listMusics} />);
};

Top100App.propTypes = exact({
    listMusics: PropTypes.object,
    slug: PropTypes.string,
});

export default Top100App;
